import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Container } from '@mui/material';
import '../../styles/StoreAdminPage.css';
import DashboardTab from '../../components/StoreAdmin/DashboardTab';
import OrdersTab from '../../components/StoreAdmin/OrdersTab';
import ProductsTab from '../../components/StoreAdmin/ProductsTab';
import { fetchUser } from '../../services/user';

export default function StoreAdminPage() {
  const [tabIndex, setTabIndex] = useState(0);
  const [storeName, setStoreName] = useState<string>('Store');

  useEffect(() => {
    const username = localStorage.getItem('userName');
    if (!username) return;
    fetchUser(username)
      .then((res) => {
        if (res.data.storeName) setStoreName(res.data.storeName);
      })
      .catch(console.error);
  }, []);

  return (
    <Container maxWidth="lg">
      <h1 className="store-admin-header">{storeName} Admin Dashboard</h1>

      <Tabs
        className="store-admin-tabs"
        value={tabIndex}
        onChange={(_, i) => setTabIndex(i)}
        textColor="inherit"
        indicatorColor="primary"
      >
        <Tab label="Dashboard" />
        <Tab label="Orders" />
        <Tab label="Products" />
      </Tabs>

      {tabIndex === 0 && <DashboardTab />}
      {tabIndex === 1 && <OrdersTab />}
      {tabIndex === 2 && storeName && <ProductsTab storeId={storeName} />}
    </Container>
  );
}
